import { render, staticRenderFns } from "./StudyProductSubscriptionList.vue?vue&type=template&id=70455f3d&scoped=true&"
import script from "./StudyProductSubscriptionList.vue?vue&type=script&lang=js&"
export * from "./StudyProductSubscriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70455f3d",
  null
  
)

export default component.exports